import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    number: '01',
    title: 'BONO 1 — Kit de Arranque Rápido',
    description: 'Empezá a vender en 7 días, no en 7 meses. Tu hoja de ruta para la primera semana: qué comprar primero, qué receta hacer primero, cómo sacar la primera foto y cómo conseguir el primer cliente. Sin vueltas.',
    value: '$14.990',
    image: ''
  }, {
    number: '02',
    title: 'BONO 2 — Calendario Express de Contenido',
    description: 'Nunca más te quedés sin saber qué postear. 30 días de ideas de contenido para Instagram y WhatsApp, adaptadas al mundo de las minidonas. Posts, historias, promociones y fechas especiales ya planificadas.',
    value: '$17.990',
    image: ''
  }, {
    number: '03',
    title: 'BONO 3 — Banco de Nombres y Frases para Vender',
    description: 'Las palabras exactas que hacen que la gente compre. +50 nombres creativos para tu emprendimiento, frases para tus historias de Instagram, textos para tu catálogo de WhatsApp y respuestas para las preguntas más comunes de tus clientes.',
    value: '$12.990',
    image: ''
  }, {
    number: '04',
    title: 'BONO 4 — Tortas y Torres Temáticas con Minidonas',
    description: 'El producto estrella que cobra el triple. Aprendé a armar tortas y torres de minidonas dignas de pastelería premium para cumpleaños, casamientos y eventos. La guía visual con paso a paso, estructuras, decoración y precios sugeridos para que vendas piezas únicas que tus clientas no encuentran en ningún otro lado.',
    value: '$19.990',
    image: 'https://cdn.magicpatterns.com/uploads/dBXBefyh2YX9EAWa6jpJbE/bono_4_-_minidonas.png',
    highlight: true,
    badge: '🔥 EL MÁS PEDIDO'
  }];
  return <section className="w-full bg-[#FBEDE5] donut-pattern py-4 md:py-8 relative" data-id="element-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 relative" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-18">
          <h2 className="text-3xl md:text-4xl font-bold text-[#3D2817] text-center mb-3 md:mb-6" data-id="element-19">
            🎁 4 BONOS ESTRATÉGICOS — SIEMPRE INCLUIDOS
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 mb-3 md:mb-5" data-id="element-20">
            {bonuses.map((bonus, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className={`rounded-lg p-4 relative overflow-hidden transition-shadow ${bonus.highlight ? 'bg-gradient-to-b from-[#FDF1E4] to-white border-2 border-[#B45309] shadow-lg ring-1 ring-[#B45309]/20 hover:shadow-xl' : 'bg-white border border-[#E8D5BA] shadow-sm hover:shadow-md'}`} data-id="element-21">
                {bonus.image && <div className="absolute top-2 right-2 w-12 h-16" style={{
              perspective: '500px'
            }} data-id="element-22">
                    <div className="relative w-full h-full rounded-sm shadow-[3px_3px_8px_rgba(61,40,23,0.25)]" style={{
                transform: 'rotateY(-12deg)',
                transformStyle: 'preserve-3d'
              }} data-id="element-23">
                      <img src={bonus.image} alt="" className="w-full h-full object-cover rounded-sm" data-id="element-24" />
                      <div className="absolute top-0 left-0 w-[3px] h-full bg-gradient-to-r from-[#B8855C] to-[#D4A373] rounded-l-sm" data-id="element-25" />
                      <div className="absolute inset-0 rounded-sm bg-gradient-to-r from-black/10 via-transparent to-transparent pointer-events-none" data-id="element-26" />
                    </div>
                  </div>}
                {bonus.highlight && bonus.badge && <div className="inline-block bg-[#B45309] text-white text-[10px] font-bold tracking-wide px-2.5 py-1 rounded-full mb-2" data-id="element-27">
                    {bonus.badge}
                  </div>}
                <div className="flex items-start gap-2 mb-2" data-id="element-28">
                  <GiftIcon className="w-5 h-5 text-[#B45309] flex-shrink-0" data-id="element-29" />
                  <span className="text-sm font-bold text-[#B45309]" data-id="element-30">
                    #{bonus.number}
                  </span>
                </div>
                <h3 className={`text-base font-bold text-[#3D2817] mb-2 ${bonus.image ? 'pr-14' : ''}`} data-id="element-31">
                  {bonus.title}
                </h3>
                <p className="text-[#6B5747] text-sm mb-3 leading-relaxed" data-id="element-32">
                  {bonus.description}
                </p>
                <div className="flex items-center gap-2" data-id="element-33">
                  <span className="text-[#9B8770] line-through text-sm" data-id="element-34">
                    {bonus.value}
                  </span>
                  <span className="text-[#5C8A6D] font-bold text-sm" data-id="element-35">
                    GRATIS
                  </span>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-center" data-id="element-36">
            <p className="text-lg md:text-xl font-bold text-[#3D2817]" data-id="element-37">
              Valor total de los bonos:{' '}
              <span className="line-through text-[#9B8770]" data-id="element-38">$65.960</span>
              {' → '}
              <span className="text-[#B45309]" data-id="element-39">GRATIS con tu Mega Pack</span>
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}